<div class="envio-container">
  <app-modal-envio-correcto
    [isOpen]="success"
    message="Operación exitosa"
    (continue)="onContinue()"
  ></app-modal-envio-correcto>
  @if(error) {
  <div class="modal-container">
    <div class="modal-cont">
      <img src="./assets/warning.svg" alt="" />
      <h3>Error</h3>
      <p>Error: {{ errorMessage }}</p>
      <label class="label-error">
        Intente nuevamente en unos minutos, si el problema persiste contacte a
        su administrador de cuentas
      </label>
      <button class="btn-m-new" (click)="onContinue()">Cerrar</button>
    </div>
  </div>
  }
</div>
<div class="page-cont col-12">
  <div class="title-cont">
    <h4 class="title-h4-blue">Administrador</h4>
    <hr />
    <button class="btn-m-new button" (click)="abrirModalAgregarUsuario()">
      <i class="bi bi-person-plus"></i>
      Agregar usuario
    </button>
  </div>
</div>

@if (showModalAgregarUsuario) {
<!-- Modal Agregar usuario -->
<div class="modal-overlay add-user">
  <div class="modal-content">
    <h4 class="title-h4-blue">Agregar nuevo usuario</h4>

    <form [formGroup]="usuarioForm" (ngSubmit)="onSubmitUsuario()">
      <div class="form-group email">
        <label class="p-g-n required-field">Correo electrónico</label>

        <div class="form-group-email">
          <input
            type="email"
            class="form-control required-field"
            formControlName="email"
            placeholder="Correo electrónico"
          />
          <span class="info-icon info-data">ℹ️</span>
        </div>
        @if (usuarioForm.get('email')?.errors?.['email'] &&
        usuarioForm.get('email')?.touched) {
        <p class="error-message">Correo electrónico no válido</p>
        }
      </div>

      <div class="form-group name">
        <label class="p-g-n required-field">Nombre</label>
        <input
          type="text"
          class="form-control"
          (keypress)="onlyLetters($event)"
          (input)="onlyLetters($event)"
          formControlName="firstName"
          placeholder="Nombre"
          [minlength]="1"
        />
      </div>

      <div class="form-group lastname">
        <label class="p-g-n required-field">Apellido</label>
        <input
          type="text"
          class="form-control"
          formControlName="lastName"
          (keypress)="onlyLetters($event)"
          (input)="onlyLetters($event)"
          placeholder="Apellido"
          [minlength]="1"
        />
      </div>

      <div class="form-group document-type">
        <label class="p-g-n required-field">Tipo de identificación</label>
        <select class="form-control" formControlName="idType">
          <option value="" selected hidden>Seleccione</option>
          @for (tipo of nameType; track tipo) {
          <option [value]="tipo.id">{{ tipo.name }}</option>
          }
        </select>
      </div>

      <div class="form-group document">
        <label class="p-g-n required-field">Identificación</label>
        <input
          type="text"
          class="form-control"
          formControlName="idNumber"
          placeholder="Identificación"
          [maxlength]="getMaxLength()"
          [minlength]="getMinLength()"
          (input)="onIdentificacionInput($event)"
        />
      </div>

      <div class="form-group phone">
        <label class="p-g-n">Teléfono</label>
        <input
          type="text"
          class="form-control"
          formControlName="phoneNumber"
          placeholder="Teléfono"
          [maxlength]="10"
          [minlength]="10"
          (input)="onlyNumbers($event)"
        />
      </div>

      <div class="form-group mobile">
        <label class="p-g-n">Celular</label>
        <input
          type="text"
          class="form-control"
          formControlName="mobileNumber"
          placeholder="Celular"
          [maxlength]="10"
          [minlength]="10"
          (input)="onlyNumbers($event)"
        />
      </div>

      <div class="modal-buttons action-buttons">
        <button class="clean-button" (click)="clearNewUser()">Limpiar</button>
        <div class="actions-buttons">
          <button
            type="button"
            class="btn-s-new"
            (click)="cerrarModalAgregarUsuario()"
          >
            Cancelar
          </button>
          <button
            type="submit"
            class="btn-m-new"
            [disabled]="!usuarioForm.valid"
          >
            Guardar
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
} @if (confirmModal) {
<div class="modal-overlay">
  <div class="modal-content-confirm">
    <h4 class="title-h4-blue">{{ confirmModalTitle }}</h4>
    <p>{{ confirmModalMessage }}</p>
    <div class="modal-actions">
      <button
        class="btn-s-new"
        (click)="confirmModalFunction($event, 'Cancelar')"
      >
        Cancelar
      </button>
      <button
        class="btn-m-new"
        (click)="confirmModalFunction($event, 'Aceptar')"
      >
        Aceptar
      </button>
    </div>
  </div>
</div>
}

<!-- Contenido Principal -->
<div class="main-content">
  <!-- Panel Izquierdo -->

  <div class="left-panel">
    <div class="form-group">
      <label class="p-g">Usuarios</label>
      <input
        list="usuarios"
        type="text"
        class="form-control"
        placeholder="Seleccionar usuario"
        (change)="onUserSelect($event)"
        [(ngModel)]="selectedUserInput"
        #userSelect
      />

      @if (users && users.length > 0) {
      <datalist id="usuarios">
        @for (user of users; track user.email) {
        <option [value]="user.email">
          {{ user.firstName }} {{ user.lastName }}
        </option>
        }
      </datalist>
      }
    </div>

    <div class="user-info">
      <div class="form-group">
        <label class="p-g">Nombre</label>
        <input
          [value]="
            selectedUser
              ? selectedUser.firstName + ' ' + selectedUser.lastName
              : ''
          "
          type="text"
          disabled
          class="form-control"
        />
      </div>

      <div class="form-group">
        <label class="p-g">Correo</label>
        <input
          type="email"
          disabled
          [value]="selectedUser?.email || ''"
          class="form-control"
        />
      </div>

      <div class="form-group">
        <label class="p-g">Tipo de identificación</label>
        <input
          type="text"
          disabled
          [value]="selectedUser?.idType || ''"
          class="form-control"
        />
      </div>

      <div class="form-group">
        <label class="p-g">Identificación</label>
        <input
          type="text"
          disabled
          [value]="selectedUser?.idNumber || ''"
          class="form-control"
        />
      </div>

      <div class="form-group buttons-container">
        @if (showPermissionButton) {
          <button class="btn-m-new permissions-button" (click)="openPermissionModal()">Otros permisos</button>
        }
        <button class="btn-s-new" (click)="clearUser()">Limpiar</button>
      </div>
    </div>
  </div>

  <!-- Panel Derecho -->

  <div class="right-panel" [class.disabled]="!selectedUser">
    @if (!selectedUser) {
    <div class="no-user-overlay">
      <div class="no-user-message">
        <div class="select-animation">
          <div class="user-icon">
            <img src="./assets/user-main.svg" alt="" />
          </div>
          <div class="cursor"></div>
        </div>
        <h1>Seleccione un usuario para continuar</h1>
      </div>
    </div>
    }
    <div class="user-header">
      <h2>Usuario</h2>

      <div class="status-container">
        <label class="p-g">Estado</label>
        <select
          class="status-select"
          [(ngModel)]="selectedStatus"
          (change)="toggleStatusChange($event)"
          [disabled]="!selectedUser"
        >
          <option value="activo">Activo</option>
          <option value="inactivo">Inactivo</option>
        </select>
        <div class="admin-checkbox">
          <input
            type="checkbox"
            id="adminCheck"
            [checked]="user.isAdmin === 'Administrador'"
            (click)="toggleAdminRole($event)"
            (change)="toggleAdminRole($event)"
            [disabled]="!selectedUser"
          />
          <label class="p-g" for="adminCheck">Administrador</label>
        </div>
        <div class="actions">
          <button
            class="btn-m-new"
            [disabled]="!hasSelectedItems()"
            (click)="guardarCambios()"
          >
            Guardar
          </button>
        </div>
      </div>
    </div>

    <div class="permissions-panel">
      <div class="permissions-table" [class.disabled]="!selectedUser">
        <div class="table-header">
          <div class="col-permiso">Permisos</div>
          <div class="col-descripcion">Descripción</div>
          <div class="col-select-all">
            <button class="btn-select-all" (click)="selectAllMenus(true)">
              <i class="bi bi-check-all"></i> Seleccionar todos
            </button>
          </div>
        </div>
        <div class="table-body">
          @for (menu of menuGroups; track menu.id) { @if
          (isMenuVisible(menu.description)) {
          <div class="permission-group">
            <div
              class="permission-row parent"
              (click)="toggleMenuExpansion(menu.description)"
            >
              <div class="checkbox-col">
                <input
                  type="checkbox"
                  [checked]="selectedItems[menu.description]"
                  (click)="
                    user.isAdmin === 'Administrador'
                      ? checkAdminPrivileges($event, menu.description)
                      : toggleParentSelection(menu.description, $event)
                  "
                />
              </div>
              <div class="description-col">
                <div class="menu-title">
                  {{ menu.description }}
                  @if (menu.subMenu) {
                  <i
                    class="bi bi-chevron-down"
                    [class.rotate]="expandedMenus[menu.description]"
                  ></i>
                  }
                </div>
              </div>
            </div>

            @if (menu.subMenu) {
            <div
              class="submenu-container"
              [class.expanded]="expandedMenus[menu.description]"
            >
              @for (submenu of menu.subMenu; track submenu.description) {
              <div class="permission-row child">
                <div class="checkbox-child">
                  <input
                    type="checkbox"
                    [checked]="
                      selectedItems[
                        menu.description + '-' + submenu.description
                      ]
                    "
                    (click)="
                      user.isAdmin === 'Administrador'
                        ? checkAdminPrivileges(
                            $event,
                            menu.description,
                            submenu.description
                          )
                        : toggleChildSelection(
                            menu.description,
                            submenu.description
                          )
                    "
                  />
                </div>
                <p>{{ submenu.description }}</p>
              </div>
              }
            </div>
            }
          </div>
          } }
        </div>
      </div>
    </div>
  </div>
</div>


@if (showPermissionModal) {
<app-modal-permisos [userSelected]="selectedUser" (confirmar)="closePermissionModal()" (cancelar)="closePermissionModal()"/>
}